import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var getInfo = normalize.getInfo(function (options) {
  var filePath = options.filePath,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  wx.getFileInfo({
    filePath: filePath,
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.WECHAT);
export default getInfo;